import styled, { css } from "styled-components";
import { borderRadius, color, units } from "@m/alchemy-theme";
import { Input } from "../input/Input";
import { TextAreaResizeIcon } from "../../icons/TextAreaResizeIcon";
export const TextAreaWrapper = styled.div `
  position: relative;
  display: ${({ isFullWidth }) => (isFullWidth ? "block" : "inline-flex")};
  width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "unset")};
  vertical-align: top; /* Safari */
`;
export const TextAreaWrapperResizer = styled(TextAreaResizeIcon) `
  position: absolute;
  bottom: 7px;
  right: 7px;
  pointer-events: none;
  z-index: 1;
  color: ${color("typeBody", { opacity: 0.55 })};
  background-color: transparent;
  display: none;

  //Only show resizer in chrome
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    display: block;
  }

  //Edge
  @supports (-ms-ime-align: auto) {
    display: none;
  }
`;
export const TextArea = styled(Input).attrs({ forwardedAs: "textarea" }) `
  overflow: hidden;
  max-height: ${({ maxHeight }) => maxHeight};

  textarea {
    border-radius: ${borderRadius("extraLarge")};
    font-size: var(--font-size, 14px);
    min-height: calc(var(--input-height, 32px) + var(--font-size, 14px));
    line-height: 1.2;
    font-family: inherit;
    display: block;
    margin: 0;
    resize: ${({ resize }) => resize};
    /* Align with Input text */
    padding-top: 7px;
    padding-bottom: 7px;
    ::-webkit-resizer {
      visibility: hidden;
      z-index: 2;
    }

    ${({ showCharacterCount }) => showCharacterCount &&
    css `
        padding-bottom: ${units(3)};
      `}

    ${({ resize }) => resize !== "none" &&
    css `
        ::-webkit-scrollbar-track {
          background: transparent;
        }
        ::-webkit-scrollbar {
          background: transparent;
        }

        ::-webkit-scrollbar-thumb {
          background: transparent;
        }

        overflow: -moz-scrollbars-none;
        -ms-overflow-style: none;
      `};

    &:read-only {
      resize: none;
    }
  }
`;
